import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import ServiceNavbar from "../cpa/components/ServiceNavbar";
import "./styles/ea.scss";

export default function Ea() {
    return (
        <section id="ea-page" aria-label="EA（Enrolled Agent）產品介紹">
        {/* banner */}
        <div className="banner ea-banner">
            <motion.div
            initial={{ opacity: 0, x: -100 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.4, default: { ease: "linear" } }}
            >
            {/* 若圖片放在 public/eaImg/ 下，請使用以 / 開頭的路徑 */}
            <img src="/eaImg/banner.png" alt="EA Banner" />
            </motion.div>
        </div>

        <div className="w-100 mt100" />

        {/* Service Nav */}
        <ServiceNavbar />

        {/* USCPA 有助生涯&職涯規劃 */}
        <div className="container mb-3 mt100 text-center">
            <div className="beckertitlename">美國註冊稅務師 (EA) 證照正式登陸台灣</div>
            <span>考試資格、科目、計分規定，中英雙語輔考方案全方位介紹</span>
        </div>

        {/* 頂端資訊條 */}
        <div className="topband" role="banner" aria-label="Becker Taiwan 頂端資訊">
            <div className="topband-inner">
            <span className="btw">Becker Taiwan</span>
            <span className="desc">｜<span className="hi">美國會計與財稅專業考照培訓</span>・原廠授權教材 × 台灣中文課程 × 顧問輔導</span>
            </div>
        </div>

        <div className="container">
            <section className="hero">
            <h1><strong>美國註冊稅務師 (Enrolled Agent)</strong></h1>
            <p className="hero-kicker">美國國稅局 (IRS) 核發，台灣人無須美籍亦可報考、取得執照</p>
            <p>考試資格、科目、計分規定，中英雙語輔考方案全方位介紹</p>
            </section>

            <div className="shell">
            <article id="ea-content" className="content" role="article" aria-label="EA 產品介紹全文">
                {/* 內文 */}
                <div className="u-w75 u-mx-auto">
                <p><strong>什麼是 EA？</strong></p>
                隨著遠距工作與斜槓接案日益普及，具備美國稅務專業資格的專才需求持續成長。<br />
                EA（Enrolled Agent，美國註冊稅務師）是由美國國稅局（IRS）直接授權的聯邦級證照，<br />
                無需美國學歷或身份，僅須通過三科專業考試，即可合法提供報稅服務並代理客戶處理所有與 IRS 有關的稅務事務。<br /><br />
                Becker Taiwan 正式推出 EA 輔考課程，協助您穩健備考、快速通關，成為 IRS 認可的稅務專業人士。
                </div>

                <div className="u-w75 u-mx-auto mt100">
                <p><strong>為什麼選擇 EA？</strong></p>
                <ul>
                    <li>具備美國聯邦認可的稅務代理資格</li>
                    <li>可在台灣遠距服務企業客戶或美籍華人個人客戶</li>
                    <li>無需美國國籍、學歷或財會背景即可報考</li>
                    <li>僅三科考試，準備期短、高通過率（60–70%）</li>
                </ul>
                </div>

                <div className="u-w75 u-mx-auto mt100 mb100">
                <p><strong>EA 證照能做什麼？</strong></p>
                <p>通過考試、取得 EA 證照後，即可獲得美國國稅局（IRS）授權的聯邦稅務代表身分，不僅具備法律效力，更可靈活運用於各種職涯與斜槓發展情境中：</p>
                <ul>
                    <li>合法代表客戶向 IRS 進行<strong>查稅回應、上訴協商與稅務爭議處理</strong></li>
                    <li>為<strong>美籍華人個人與企業客戶辦理報稅與稅務策略規劃</strong></li>
                    <li>與在台記帳士事務所、跨國會計師事務所合作，<strong>拓展美國稅務服務項目</strong></li>
                    <li>作為<strong>接案者或創業者</strong>經營報稅服務，<strong>建立穩定副業收入來源</strong></li>
                    <li>結合財稅顧問職能，<strong>提供跨境電商與美籍客戶合法合規建議</strong></li>
                </ul>
                <p>無論您是專業會計人員、跨境電商業者、在台外商從業者或尋找轉職、兼職契機者，EA 都是一張具備實務價值、靈活應用的專業證照。</p>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>為什麼「先考 EA，再考 CPA」是聰明的起點？</strong></span></h2>
                <p className="mt-5">相較於科目繁多、涵蓋全面的美國 CPA 考試，<span className="bw"><strong>EA 聚焦於美國稅法與稅務實務，是一張更容易入門、短期內即可完成準備的證照</strong></span>。對於尚未符合 CPA 報考資格，或希望先打穩基礎的學員而言，EA 是極具策略性的第一步。</p>
                <p>EA 的考試內容涵蓋 CPA 考試中最具挑戰的稅務科目（如 REG 與 TCP）中約六至七成的核心考點，包含個人稅、企業稅與稅務代理流程。<strong>透過先取得 EA，可有效建立稅法底層邏輯，降低後續 CPA 應試壓力</strong>，更快掌握重點，循序漸進邁向完整的會計專業力。</p>
                <p>需要特別說明的是：<strong><span className="bw">若您已通過美國 CPA 或美國律師考試，通常不需再考 EA</span>，因為 CPA 和律師已具備包含稅務在內的全面代理權力。</strong></p>
                <p>適合對象簡析：</p>
                <ul>
                    <li><span className="bw"><strong>EA 執照適合</strong></span>：希望以最迅速方式取得一張「得線上跨境提供服務」的美國執照，從事報稅、稅務顧問、或希望擁有代表客戶與 IRS 溝通權限的人士。</li>
                    <li><span className="bw"><strong>CPA 執照適合</strong></span>：希望具備完整執業能力（含審計、財務會計與稅務）與會計師頭銜，以進入會執業計師或跨國財會職涯者，並獲進一步抵換他國會計師執照。</li>
                </ul>
                <p>因此，對於希望從稅務領域快速切入美國財會體系的初學者來說，<strong>從 EA 起步，再銜接 CPA，將是一條風險低、回報高的最佳路徑。</strong></p>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>EA 考試架構與安排（SEE：Special Enrollment Examination）</strong></span></h2>
                <p className="mt-5">美國註冊稅務師（EA）考試由美國國稅局（IRS）授權，透過 Prometric 測驗中心統一舉辦，分為三個主題科目，考試題型與制度簡單明確，適合短期準備與有效進步。</p>
                <p><strong>考試科目與通過率（2022–2023 年官方資料）：</strong></p>

                {/* 表格在小螢幕時會自動可水平捲動 */}
                <div className="table-wrap">
                    <table className="table text-center align-middle">
                    <thead>
                        <tr>
                        <th>科目名稱</th>
                        <th>科目範圍</th>
                        <th>通過率</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr><td>Part 1</td><td>個人稅務（Individuals）</td><td>約 60%</td></tr>
                        <tr><td>Part 2</td><td>企業稅務（Businesses）</td><td>約 69%</td></tr>
                        <tr><td>Part 3</td><td>稅務代理與執業規範（Representation, Practices and Procedures）</td><td>約 70%</td></tr>
                    </tbody>
                    </table>
                </div>

                <p><strong>考試方式與安排：</strong></p>
                <ul>
                    <li>題型：全部為四選一選擇題（Multiple Choice），每科 100 題</li>
                    <li>考試時間：每科 4 小時（含考前簡介與考後問卷），其中包含一次 15 分鐘休息</li>
                    <li>報考彈性：三科可依個人順序自由安排考試，須於三年內完成所有科目以取得資格</li>
                    <li>分數計算：分數範圍為 40 至 130，及格分數為 105。</li>
                    <li>考場地點：官方指定 Prometric 考場單位，全美皆可應考 SEE，離台灣最接近的考點為關島。此外，近年亞洲地區偶爾開放之國際考場包含：東京、新加坡、首爾（實際開放不固定）。</li>
                </ul>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>Becker Taiwan EA 輔考方案比較</strong></span></h2>
                <p>無論你是短期衝刺型，還是重視完整配備與備考彈性的長期規劃者，Becker Taiwan 都為你準備了合適的選擇。</p>

                <p><span className="bw"><strong>EA 速成方案（3–6 個月通關）</strong></span></p>
                <p>適合：英文程度佳、時間有限、目標明確、偏好線上自學者</p>
                <ul>
                    <li>Becker 原廠授權教材（含英文電子書、題庫、模擬考系統）</li>
                    <li>全科中文補充課程（共 36 小時）</li>
                    <li>中英文字幕教學影片</li>
                    <li>超過 3,000 題練習題＋解析影片</li>
                    <li>自動 study plan 排課功能、模擬考模式、進度追蹤功能</li>
                    <li>支援行動與桌面裝置同步使用</li>
                    <li>12 個月使用效期</li>
                </ul>

                <p><span className="bw"><strong>EA 完勝方案（長期備考＋紙本加持）</strong></span></p>
                <p>適合：重視學習彈性、偏好紙本教材的穩健型考生</p>
                <ul>
                    <li>含以上 EA 速成方案所有內容！</li>
                    <li>再加上：全科紙本教科書一套（共三本）</li>
                    <li>再加上：報考 SEE 操作流程，顧問諮詢解說影片（2025 年 8 月後上線）</li>
                    <li>再加上：「持續展延資格」：12 個月內若未通過考試，可多次免費延長使用權限</li>
                    <li>再加上：若有科目上完課程、應考但未通過，持成績單證明得再次參加該科中文課程完整一次！</li>
                    <li>再加上：一門 IRS 指定美國註冊稅務師「執業道德類」考後進修課程 (Becker Ethics CE course)</li>
                </ul>

                <div className="br mt100 mb100" />
                <h2><strong><span className="dw">立即試聽 Becker EA 美師概念講解影片！</span></strong></h2>

                {/* 影片 RWD 容器 */}
                <div className="embed" aria-label="Becker EA 概念講解影片">
                    <iframe
                    src="https://www.youtube.com/embed/E9sjvE8fyno"
                    title="Becker EA 概念講解影片"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                    />
                </div>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>方案比較表</strong></span></h2>
                <p>
                    <img
                    alt="2025 EA 方案比較表（兩種，不含自修、不含優惠）"
                    className="w-100 mt-5 mb-5 zoomable"
                    src="https://www.beckertw.com/uploads/news/1762139709089_2025%20EA%20%E6%96%B9%E6%A1%88%E6%AF%94%E8%BC%83%E8%A1%A8%EF%BC%88%E5%85%A9%E7%A8%AE%EF%BC%8C%E4%B8%8D%E5%90%AB%E8%87%AA%E4%BF%AE%EF%BC%8C%E4%B8%8D%E5%90%AB%E5%84%AA%E6%83%A0%EF%BC%89.png"
                    />
                </p>

                <div className="br mt100 mb100" />
                <h2><span className="dw mb-5 mt-5"><strong>報考資訊與考試安排</strong></span></h2>
                <ul>
                    <li>考試科目：個人稅務、企業稅務、稅務代理與執業規範，共 3 科</li>
                    <li>題型皆為四選一選擇題，每科 100 題，無寫作或計算題</li>
                    <li>每科實際考試時間為 3.5 小時（另有半小時可供登入、閱讀規定、與一次 15 分鐘的休息）</li>
                    <li>每科考試最終結尾，應試螢幕上將直接顯示「及格 / 不及格」的訊息</li>
                    <li>須於三年內通過三科（滾動式保留）</li>
                    <li>每年 5 月至隔年 2 月，全時間開放應考（3–4 月暫停考試以更新試題）</li>
                    <li>考試地點：Prometric 美國考場（東京、新加坡、首爾常見設點）</li>
                    <li>通過後可直接申請 EA 執照，無需額外工作經驗或學歷審核</li>
                </ul>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>EA 中文課程：實體授課＋線上備選，完整學習體驗</strong></span></h2>
                <p className="mt-5">凡購買任一 EA 輔考方案（速成／完勝），皆包含 Becker Taiwan 提供的<strong>中文教學課程</strong>，協助母語非英語的考生系統性掌握 IRS 考試所需的稅法知識與實務應用。</p>
                <p><span className="rw"><strong>教學方式｜請於報名時擇一選擇上課方式</strong></span></p>
                <p>為配合不同學習需求，中文課程提供兩種上課形式，<strong>請學員於填寫報名表時選擇其中一種</strong>：</p>
                <ol>
                    <li><span className="bw"><strong>中文面授課程（優先推薦！）</strong></span>
                    <ul>
                        <li><strong>授課形式</strong>：講師現場授課，課堂互動與即時問</li>
                        <li><strong>開課時間</strong>：自 2025 年 11 月 1 日起，每週六（上午一堂、下午一堂，每堂 3 小時，共 36 小時）</li>
                        <li><strong>上課地點</strong>：Becker Taiwan 面授教室（台北市，大安捷運站共構大樓）</li>
                        <li><strong>詳細課表</strong>：<a href="https://beckertw.com/home/newdetail/620" target="_blank" rel="noreferrer noopener">點此閱覽開課公告</a>（含詳細課表、師資介紹），<strong>2025 年底前完成三科課程授課進度</strong><br /><br />建議盡可能參與實體課程，以利即時互動、現場問答與練習。</li>
                    </ul>
                    </li>
                    <li><span className="bw"><strong>中文線上課程（限無法到場者）</strong></span>
                    <ul>
                        <li><strong>授課形式</strong>：實體課程全程錄影，製成單元式教學影片，供學員於雲端隨選隨看</li>
                        <li><strong>觀看方式</strong>：於 Becker 線上平台隨選隨看，進度彈性、自行安排<br /><br />面授與線上為擇一參與機制，<strong>請於報名表中勾選您的首選方式</strong>，以利後續安排。</li>
                    </ul>
                    </li>
                </ol>

                <div className="br mt100 mb100" />
                <h2><span className="dw mt-5"><strong>中文面授專業師資團隊介紹</strong></span></h2>
                <p className="gw mt-5"><strong>Tim Lee 老師</strong></p>
                <p>Tim 老師具備美國名校法律與稅法雙碩士背景，擁有豐富跨境稅務經驗，將使用 Becker 教材以中文授課，深入淺出講解 IRS 稅法邏輯與應用場景。</p>
                <p className="mt-5"><strong>講師學歷：</strong></p>
                <ul><li>美國波士頓大學 稅法碩士</li><li>美國伊利諾大學香檳分校 法學碩士</li></ul>
                <p><strong>專業經歷：</strong></p>
                <ul>
                    <li>美國聯邦及州稅申報、信託稅</li>
                    <li>IRS 稅務爭議處理與來函回覆</li>
                    <li>美國稅法與信託法研究與教學</li>
                    <li>現任職於 KEDP CPAs Group</li>
                </ul>

                <div className="br mt100 mb100" />
                <p className="gw"><strong>MJ Chang 老師</strong></p>
                <p>MJ 老師具備臺灣註冊會計師、美國註冊會計師資格，持美國企業稅務多年實務經驗。課程以中文講授，奠基 Becker 教材並搭配案例，幫助理解 IRS 規定與考試重點。</p>
                <p><strong>講師學歷：</strong><br />淡江大學會計學系學士</p>
                <p><strong>專業經歷：</strong></p>
                <ul>
                    <li>美國聯邦及州稅申報</li>
                    <li>稅務局查核因應及文件準備</li>
                    <li>外商公司財務主管、台灣百大企業會計主管經驗</li>
                </ul>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>立即報名</strong></span></h2>
                <p>Becker Taiwan EA 輔考課程方案，優惠價開放中。立即填寫下方報名表完成購買，客服將與您聯繫教材領取與課程方式設定（面授/線上）。</p>

                <section id="pricing" aria-label="價格與方案">
                    <p><strong><span className="rw">EA 輔考方案價格：</span></strong></p>
                    <div className="pricing">
                    <div className="price-item">
                        <div className="pi-title">EA 速成方案</div>
                        <p className="pi-line">原價 NT$40,000（現在售價恢復原價無優惠）</p>
                    </div>
                    <div className="price-item">
                        <div className="pi-title">EA 完勝方案（含紙本教材＋展延） <span className="badge">周年慶</span></div>
                        <p className="pi-line">
                        原價 NT$50,000<br />
                        <span style={{ color: "#b51759" }}><strong>周年慶優惠價 NT$47,000</strong></span>（2025/11/1–2025/11/30）
                        </p>
                    </div>
                    </div>
                </section>

                <div className="br mt100 mb100" />
                <h2><span className="dw"><strong>填寫報名表 → 完成預約流程：</strong></span></h2>
                <p>
                    點此詳讀報名同意事項、填寫報名表與完成購買
                    <Link to="/quickbuy" target="_blank" className="ml-2">
                    <button className="btn btn-success"><strong>申請報名</strong></button>
                    </Link>
                </p>
                <p>完成購買後，1 個工作日內寄出「購買確認信」與登入資訊；您可選擇隨時啟用教材效期。</p>
                <p>有關 EA 的問題？<Link to="/faq?tab=ea">點此查看 EA 常見問答</Link></p>
                <p>或立即至官方 LINE 取得一對一支援：<a href="https://line.me/R/ti/p/%40vtz1908l" target="_blank" rel="noreferrer noopener">點此聯繫 LINE 客服</a></p>
                </div>
            </article>

            {/* 側欄 */}
            <aside className="side" aria-label="側欄">
                <div className="card-wrap">
                    <div className="card">
                    <h4>目錄</h4>
                    <ul>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=%E7%82%BA%E4%BB%80%E9%BA%BC%E3%80%8C%E5%85%88%E8%80%83%20EA%EF%BC%8C%E5%86%8D%E8%80%83%20CPA%E3%80%8D%E6%98%AF%E8%81%B0%E6%98%8E%E7%9A%84%E8%B5%B7%E9%BB%9E%EF%BC%9F,-%E7%9B%B8%E8%BC%83%E6%96%BC%E7%A7%91%E7%9B%AE" target="_blank" rel="noreferrer noopener">為什麼「先考 EA，再考 CPA」是聰明的起點？</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=EA%20%E8%80%83%E8%A9%A6%E6%9E%B6%E6%A7%8B%E8%88%87%E5%AE%89%E6%8E%92" target="_blank" rel="noreferrer noopener">EA 考試架構與安排</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=EA%20%E8%BC%94%E8%80%83%E6%96%B9%E6%A1%88%E6%AF%94%E8%BC%83" target="_blank" rel="noreferrer noopener">EA 輔考方案比較</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=%E7%AB%8B%E5%8D%B3%E8%A9%A6%E8%81%BD%20Becker%20EA%20%E7%BE%8E%E5%B8%AB%E6%A6%82%E5%BF%B5%E8%AC%9B%E8%A7%A3%E5%BD%B1%E7%89%87%EF%BC%81" target="_blank" rel="noreferrer noopener">試聽美師講解影片</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=%E5%A0%B1%E8%80%83%E8%B3%87%E8%A8%8A%E8%88%87%E8%80%83%E8%A9%A6%E5%AE%89%E6%8E%92" target="_blank" rel="noreferrer noopener">報考資訊與考試安排</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=EA%20%E4%B8%AD%E6%96%87%E8%AA%B2%E7%A8%8B" target="_blank" rel="noreferrer noopener">EA 中文課程</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=%E4%B8%AD%E6%96%87%E9%9D%A2%E6%8E%88%E5%B0%88%E6%A5%AD%E5%B8%AB%E8%B3%87%E5%9C%98%E9%9A%8A%E4%BB%8B%E7%B4%B9" target="_blank" rel="noreferrer noopener">中文面授專業師資介紹</a></li>
                        <li><a href="https://www.beckertw.com/home/newdetail/629#:~:text=%E7%AB%8B%E5%8D%B3%E5%A0%B1%E5%90%8D" target="_blank" rel="noreferrer noopener">立即報名</a></li>
                    </ul>
                    </div>

                    <div className="card">
                    <h4>聯絡我們</h4>
                    <a className="btn btn-primary" aria-label="洽詢" id="ea-cta-side" href="https://page.line.me/vtz1908l?openQrModal=true" target="_blank" rel="noreferrer noopener">立即洽詢</a>
                    </div>
                </div>
            </aside>
        </div>
            <div className="divider" role="separator" aria-hidden="true"><br /></div>
        </div>
        </section>
    );
}
